<template>
  <div class="login-body">
    <div class="login">
      <v-container fluid>
        <v-row>
          <v-col cols="12">
            <h1 class="login-title">VOISS</h1>
            <v-text-field
              v-model="email"
              :label="$t('Form.account.title')"
              :placeholder="$t('Form.account.placeholder')"
              type="email"
              required
            ></v-text-field>
            <v-text-field
              v-model="password"
              :label="$t('Form.password.title')"
              :placeholder="$t('Form.password.placeholder')"
              type="password"
              required
            ></v-text-field>
            <v-btn color="primary" block @click="btnLogin" depressed>{{$t('Form.login')}}</v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn text @click="btnLogin" depressed>{{$t('Form.forgetPassword')}}</v-btn>
          </v-col>
          <v-col cols="6" class="d-flex justify-end">
            <div class="d-flex flex-column btn-columns">
              <v-btn @click="btnRegister">
                {{$t('Form.register')}}
              </v-btn>
              <v-btn
                color="grey lighten-5"
                v-google-signin-button="googleClientId"
                class="google-signin-button black--text"
                depressed
              >
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 48 48" class="abcRioButtonSvg"><g><path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path><path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path><path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path><path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path><path fill="none" d="M0 0h48v48H0z"></path></g></svg>
                <span class="d-inline-block" style="width: 0.5rem;"></span>
                {{$t('Form.loginWithGoogle')}}
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-container>

      <!-- <h1 class="login-title">Login System</h1> -->
      <!-- <div class="r-row" style="margin-top:50px;">
        <label>Account</label>
        <input type="text" name="email" v-model="email" value="" />
      </div>
      <div class="r-row" style="margin-top:10px;">
        <label>Password</label>
        <input type="password" name="password" v-model="password" value="" />
      </div> -->
      <!-- <div class="r-row" style="margin-top:10px;">
        <label style="width:213px;">Forget Password</label>
        <label @click="btnRegister">Register</label>
      </div> -->
    </div>
  </div>
</template>
<script>
import * as jwt from 'jsonwebtoken'
import { loginByToken } from '@/lib/auth/google-login'
import GoogleSignInButton from 'vue-google-signin-button-directive'
/* eslint-disable no-unused-vars */
import axios from '@/lib/axios'
import qs from 'qs'

export default {
  directives: {
    GoogleSignInButton
  },
  data() {
    return {
      email: '',
      password: '',
      googleClientId:
        '349564250888-2i0pn4knna685jtmm9t5ogrrai3k1fpe.apps.googleusercontent.com'
    }
  },
  methods: {
    async btnLogin() {
      if (!this.email) {
        this.$toast.error('請輸入帳號')
        return ''
      }
      if (!this.password) {
        this.$toast.error('請輸入密碼')
        return ''
      }
      /* axios.defaults.headers['Methods'] = 'POST' */
      axios
        .post(
          process.env.VUE_APP_API_ENDPOINT + '/wordprison/login/',
          { email: this.email, password: this.password },
          {
            withCredentials: true
          }
        )
        .then((res) => {
          if (res.data.code === 200) {
            console.log(res.data)
            this.$store.commit('user/setup', res.data.user)
            this.loginRedirect()
          } else {
            alert(res.data.message)
          }
        })
        .catch(function(error) {
          console.log(error)
        })
    },
    btnRegister() {
      this.$router.push('/home/register')
    },
    // btnGoogle() {
    //   this.$router.push('/home/google')
    // }
    OnGoogleAuthSuccess(idToken) {
      // window.jwt = jwt
      // console.debug(idToken)
      // 解析收到的資訊 console.log(jwt.decode(idToken))
      loginByToken(idToken)
        .then((res)=>{
          if(res.data.user){
            this.$store.commit('user/setup', res.data.user)
            this.loginRedirect()
          }
        })
        .catch((e)=>{
          console.error(e)
        })
    },
    OnGoogleAuthFail(error) {
      console.log(error)
    },
    loginRedirect(){
      let to = this.$route.query.to
      if(to === '$assistant'){
        this.loginAssistant()
      }else{
        this.$router.push('/home/screenplays')
      }
    },
    async loginAssistant(){
      let {
        client_id: cliendId,
        redirect_uri: redirectUri,
        response_type: responseType,
        state
      } = this.$route.query
      if(cliendId && redirectUri && responseType && state){
        try{
          let res = await axios.post('/wordprison/auth/assistant')
          if(res.data.code === 0){
            let token = res.data.payload.token.token
            location.href = redirectUri + '#' + qs.stringify({
              access_token: token,
              token_type: 'bearer',
              state
            })
          }else{
            alert('login failed')
          }
        }catch(e){
          alert('login failed')
        }
      }
    }
  }
}
</script>
<style scoped>
.btn-columns .v-btn{
  margin-bottom: 0.8rem;
}
.login-body {
  padding-top: 100px;
  width: 100%;
  height: 100%;
}
.login {
  margin: 0 auto;
  max-width: 500px;
  border: 1px solid #fdc660;
}
.login-title {
  text-align: center;
  margin-top: 20px;
}
</style>
